module.exports = __webpack_public_path__ + "assets1752042029796/img/error-404.94756dcf.svg";